import React from 'react';
import { useParams } from 'react-router-dom';
import windowService from '../../../services/windowService';

type UseStepConfigParams = {
  setCurrentStep: React.Dispatch<React.SetStateAction<'select' | 'form' | 'preview' | 'upload'>>;
};

export const useStepConfig = ({ setCurrentStep }: UseStepConfigParams) => {
  const { buildType } = useParams<{ buildType: string }>();

  return {
    assessment: {
      icon: 'fas fa-file-alt',
      title: 'Assessment',
      description: 'Assessment',
      primaryAction: () => windowService.redirectTo(`/manage-training/${buildType}/content`),
      primaryActionText: 'Add Assessment',
    },
    download: {
      icon: 'fas fa-download',
      title: 'Download',
      description: 'Download',
      primaryAction: () => setCurrentStep('upload'),
      primaryActionText: 'Upload File',
    },
    documentViewer: {
      icon: 'fas fa-file-alt',
      title: 'Document Viewer',
      description: 'Document Viewer',
      primaryAction: () => setCurrentStep('upload'),
      primaryActionText: 'Upload Document',
    },
    video: {
      icon: 'fas fa-play',
      title: 'Video',
      description: 'Video',
      primaryAction: () => setCurrentStep('upload'),
      primaryActionText: 'Upload Video',
    },
    audio: {
      icon: 'fas fa-volume-up',
      title: 'Audio',
      description: 'Audio',
      primaryAction: () => setCurrentStep('upload'),
      primaryActionText: 'Upload Audio',
    },
  };
};
